/**
 * A host may say where a Google sign-in should land afterwards. The value is only ever used
 * as a path inside this app: this returns it as `path?query#hash` when it is a same-origin
 * relative path, and `null` for everything else (a full URL, a protocol-relative `//host`,
 * a backslash or control character, or anything the URL parser resolves to another origin
 * or to a path that itself begins `//`). `returnPath.test.ts` has the cases.
 */
export function sameOriginPath(value: string | undefined | null, origin: string = window.location.origin): string | null {
  if (!value || !value.startsWith('/') || value.startsWith('//')) return null;
  if (/[\\\u0000-\u001f\u007f]/.test(value)) return null;
  let url: URL;
  try {
    url = new URL(value, origin);
  } catch {
    return null;
  }
  if (url.origin !== origin) return null;
  const path = url.pathname + url.search + url.hash;
  return path.startsWith('/') && !path.startsWith('//') ? path : null;
}
